<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <div *ngIf="loggedIn">
        <fuse-vertical-navigation class="bg-white print:hidden" [mode]="'over'" [name]="'mainNavigation'"
            [navigation]="navigation.defaultLogin" [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationHeader>
                <!-- Logo -->
                <div class="flex flex-row items-center h-20 py-6 px-8">
                    <img class="w-full" src="assets/images/logo/logo.svg" alt="Logo image" loading="lazy">
                </div>

            </ng-container>
            <ng-container fuseVerticalNavigationFooter>
                <!-- Log in-out -->
                 <div class="bg-primary">
                    <button mat-button class=" text-primary mx-2 bg-primary-50 my-2 font-bold justify-end" mat-flat-button (click)="signOut()">
                        Log Out
                    </button>
                 </div>
            </ng-container>
        </fuse-vertical-navigation>
    </div>

    <div *ngIf="!loggedIn">
        <fuse-vertical-navigation class="bg-white print:hidden" [mode]="'over'" [name]="'mainNavigation'" 
            [navigation]="navigation.default" [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationHeader>
                <!-- Logo -->
                <div class="flex flex-row items-center h-20 py-6 px-8 hover:cursor-pointer" [routerLink]="['/']">
                    <img class="w-full" src="assets/images/logo/logo.svg" alt="Logo image" loading="lazy">
                </div>
            </ng-container>
            <ng-container fuseVerticalNavigationContentFooter>
                <!-- Log in-out -->
                <button mat-button class=" text-primary mx-2 bg-accent my-8 font-bold" mat-flat-button [routerLink]="['/']" mat-flat-button>
                    Check Coverage
                </button>
            </ng-container>
            <ng-container fuseVerticalNavigationFooter>
                <!-- Log in-out -->
                <button mat-button class=" text-primary mx-2 bg-primary-50 my-8 font-bold" mat-flat-button [routerLink]="['/sign-in']" >
                    Log In/Register
                </button>
            </ng-container>
        </fuse-vertical-navigation>
    </div>
</ng-container>
<!-- Wrapper -->
<div class="flex-col flex-auto items-center w-full min-w-0 dark:bg-card">
    <!-- Header -->
    <div class="sticky top-0 flex flex-col flex-0 justify-center w-full overflow-hidden z-999 shadow dark:shadow-none print:hidden">
        <!-- Top bar -->
        <div class="relative dark justify-center w-full px-4 md:px-8 bg-secondary-200 dark:bg-gray-900">
            <div class="flex items-center w-full h-16 sm:h-20 justify-between">
                
                <ng-container *ngIf="!isScreenSmall">
                    <!-- Logo -->
                    <div class="flex flex-row items-center px-8 w-full ">
                        <img [routerLink]="['/']" class="w-50 h-50 hover:cursor-pointer" src="assets/images/logo/logo.svg" alt="Logo image" loading="lazy">
                    </div>
                    <div class="flex justify-end ">
                        <!-- <app_network_panel></app_network_panel> -->
                        <button *ngIf="showCart()" class="purple-button font-semibold py-2 px-6 mr-2 hover:bg-secondary-500" aria-label="Go to cart" [routerLink]="['/cart']" (click)="signUpRequired()">
                            <mat-icon class="icon-colour" matBadgeColor="accent" matBadge="{{cartValue !== 0 ? cartValue : ''}}" svgIcon="heroicons_solid:shopping-cart"></mat-icon>
                        </button>
                        <ng-container *ngIf="loggedIn">
                            <button  [matMenuTriggerFor]="accountMenu" class="purple-button font-semibold p-2 rounded-full ">
                                {{shortenedProfileDisplay}}
                            </button>
                            
                            <div class="flex align-center justify-between items-center">
                                <mat-icon class="text-black icon-size-8 hover:cursor-pointer " svgIcon="mat_solid:arrow_drop_down" [matMenuTriggerFor]="accountMenu"></mat-icon>
                            </div>
                            
                            <mat-menu #accountMenu="matMenu" class="pb-0 rounded-md">                                
                                <button mat-menu-item (click)="menuItemClick('dashboard')">
                                    <p class="font-bold">Dashboard</p>
                                </button>
                                <button mat-menu-item (click)="menuItemClick('dashboard','profile')">
                                    <p class="font-bold">My Profile</p>
                                </button>
                                <button mat-menu-item [matMenuTriggerFor]="billingAndInvoices" (click)="menuItemClick('dashboard','invoices')">
                                    <p class="font-bold">Billing</p>
                                </button>
                                <button mat-menu-item class="purple-menu-item" (click)="signOut()">
                                    <p class="text-primary font-extrabold">Logout</p>
                                </button>
                            </mat-menu>
                            <mat-menu #billingAndInvoices="matMenu">
                                <button mat-menu-item (click)="menuItemClick('dashboard','invoices', 'billing')">
                                    <p class="font-bold">Billing</p>
                                </button>
                                <button mat-menu-item (click)="menuItemClick('dashboard','invoices', 'statements')">
                                    <p class="font-bold">Statements</p>
                                </button>
                                <button mat-menu-item (click)="menuItemClick('dashboard','invoices', 'invoices')">
                                    <p class="font-bold">Invoices</p>
                                </button>
                              </mat-menu>                           
                        </ng-container>
                        <ng-container *ngIf="!loggedIn">
                            <button class="purple-button font-semibold py-2 px-6" (click)="signIn()">
                                <mat-icon class="icon-colour" svgIcon="heroicons_solid:user"></mat-icon>Login
                            </button>
                        </ng-container>
                        
                    </div>
                </ng-container>
                <!-- Navigation toggle button -->
                <ng-container *ngIf="isScreenSmall">
                    <div class="w-full flex flex-row justify-between items-center">
                        <div>
                            <button
                                mat-icon-button
                                (click)="toggleNavigation('mainNavigation')">
                                <mat-icon  [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                            </button>
                        </div>
    
                        <div>
                            <img [routerLink]="['/']" class="w-36 hover:cursor-pointer mt-2" src="assets/images/logo/logo.svg" alt="Logo image" loading="lazy">
                        </div>

                        <div class="flex flex-row space-x-8">
                            <!-- <mat-icon class="text-primary" [svgIcon]="'heroicons_solid:user'"></mat-icon> -->
                            <button *ngIf="showCart()" class="flex flex-row items-center rounded-full py-1" [routerLink]="['/cart']" (click)="signUpRequired()">
                                <mat-icon class="icon-size-5 text-primary-500" svgIcon="heroicons_solid:shopping-cart">
                                </mat-icon>
                            </button>
                             <button *ngIf="!loggedIn" class="flex flex-row items-center rounded-full py-1" [routerLink]="['/sign-in']">
                                <mat-icon class="icon-size-5 text-primary-500" svgIcon="heroicons_solid:user"></mat-icon>
                                <!-- <span class="text-primary-500 font-bold text-md">Login</span> -->
                             </button>
                             <button *ngIf="loggedIn" class="flex flex-row items-center rounded-full py-1" [routerLink]="['/dashboard']">
                                <mat-icon class="icon-size-5 text-primary-500" svgIcon="heroicons_solid:user"></mat-icon>
                                <!-- <span class="text-primary-500 font-bold text-md">Login</span> -->
                             </button>
                        </div>

                    </div>
                </ng-container>
            </div>
        </div>
        <!-- Menu bar -->
        <ng-container *ngIf="!isScreenSmall">
            <div class="flex flex-auto px-4 md:px-8 bg-primary-500 dark:bg-gray-700 text-white py-4">
                <div class="items-center w-full max-w-full px-10">
                    <fuse-horizontal-navigation [name]="'mainNavigation'" [navigation]="navigation.horizontalLoggedIn">
                        
                      </fuse-horizontal-navigation>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Content -->
    <div class="flex-auto justify-center w-full overflow-hidden">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <app-footer (focusInput)="focusOnSearch()"></app-footer>

</div>

<ng-template #inActivityDialog>

  <div>
    <div class="flex flex-col justify-center items-center">
      <mat-icon class="text-primary icon-size-10" svgIcon="heroicons_outline:cursor-arrow-rays"></mat-icon>
      <h1 class="font-extrabold text-xl py-6">
        Inactivity detected.
      </h1>
    </div>
    <h2 class="text-sm text-center pb-6">
      You will be signed out in <span class="font-bold">{{countDownValue}}</span> seconds.
    </h2>

    <div class="flex justify-end">
        <button
            class="flex flex-row justify-center items-center"
            [color]="'primary'"
            type="button"
            (click)="resetInactivityTimer()"
            mat-flat-button
        >
            Don't sign me out!
        </button>
    </div>
  </div>

</ng-template>